import React from 'react';
import { Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
//translations
import { useTranslation } from 'react-i18next';
//redux
import { useSelector } from 'react-redux';
import { cartSelector } from 'slices/cart';
import { userSelector } from 'slices/user';
import { companySelector } from 'slices/company';
//api
import { updateCartDetails } from 'api/ecommerce';

const TPV = ({ redsys = null, infoDataDisabled = false }) => {
  const { t } = useTranslation(['payment', 'shipping']);
  const { id: bookstoreId } = useSelector(companySelector);
  const { benefitedBookstore, pickUpLibrary } = useSelector(userSelector);
  const { isStorePickup, items, billingCartAddress, shippingCartAddress, contactInfo } = useSelector(cartSelector);

  const routeRedsysHistory = () => {
    if (!localStorage.getItem('historyRedsys')) {
      localStorage.setItem('historyRedsys', redsys.Target_Url.includes('redsys'));
    }
  };

  const handleUpdateCartDetails = async () => {

    const payload = {
      items: items,
      empresa: bookstoreId,
      store_pickup: isStorePickup,
      billing_address: billingCartAddress,
      shipping_address: shippingCartAddress,
      bookstore_to_pickup: pickUpLibrary,
      benefited_company: benefitedBookstore?.value,
      contact_info: contactInfo,
    }
    try {
      const response = await updateCartDetails(payload);
      console.log('Cart details updated', response);
      
    } catch (error) {
      console.error('Error updating cart details', error);
    }
  };

  const handleSubmitRedsys = async(event) =>{
    event.preventDefault();
    routeRedsysHistory();
    try {
      await handleUpdateCartDetails();
      const form = document.getElementById('redsys');
      form.submit();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  }

  return (
    <>
      {redsys ? (
        <>
          <form id="redsys" name="from" action={redsys.Target_Url} method="POST">
            <input type="hidden" name="Ds_SignatureVersion" value={redsys.Ds_SignatureVersion} />
            <input type="hidden" name="Ds_MerchantParameters" value={redsys.Ds_MerchantParameters} />
            <input type="hidden" name="Ds_Signature" value={redsys.Ds_Signature} />
            {infoDataDisabled ?
              <OverlayTrigger
                overlay={<Tooltip id="button-tooltip2">{t('completeFields', { ns: 'shipping' })}</Tooltip>}
              >
                <span className="d-inline-block">
                  <Button
                    type="submit"
                    name="enviar"
                    className="orange-btn p-2 text-white disabled"
                    onClick={(e) => handleSubmitRedsys(e)}
                    disabled
                    size='sm'
                  >
                    {t('buyNow').toUpperCase()}
                  </Button>
                </span>
              </OverlayTrigger> :
              <Button
                type="submit"
                name="enviar"
                className="orange-btn p-2 text-white"
                onClick={(e) => handleSubmitRedsys(e)}
                size='sm'
              >
                {t('buyNow').toUpperCase()}
              </Button>}
          </form>
        </>
      ) : (
        <Row>{t('processing')}</Row>
      )}
    </>
  );
};

export default TPV;
